import { Component } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

@Component({
    selector: 'lib-confirm-dialog',
    templateUrl: './confirm-dialog.component.html',
    styleUrls: ['./confirm-dialog.component.css']
})
export class ConfirmDialogComponent {

    public static OK: string = "OK";
    public static Cancel: string = "Cancel";

    public itemName: string;
    public title: string;
    public confirmMessage: string;
    public acceptStyleClass: string = 'btn-primary';

    constructor(
        private modalService: BsModalService,
        public bsModalRef: BsModalRef,
    ) {
    }

    public onAccept(e: MouseEvent): void {
        e.preventDefault();
        this.closeForm(ConfirmDialogComponent.OK);
    }

    public onCancel(e: MouseEvent): void {
        e.preventDefault();
        this.closeForm(ConfirmDialogComponent.Cancel);
    }

    private closeForm(reason?: string): void {
        this.modalService.setDismissReason(reason);
        this.modalService.hide(this.bsModalRef.id);
    }
}
